import { useTranslation } from "../context/TranslationContext";
import MintSpaceSupportHub from "../components/MintSpaceSupportHub";

const MintSpaceSupportPage = ({
  isDark,
  setToast,
  mintSpace,
  onSupportUnreadChange,
  isMintSpaceOwner = false,
  isMintSpaceModerator = false,
}) => {
  const { t } = useTranslation();

  if (!mintSpace) {
    return (
      <div className="flex items-center justify-center min-h-[200px]">
        <div className="text-slate-500">Loading...</div>
      </div>
    );
  }

  if (!mintSpace.pages?.support?.enabled) {
    return (
      <div className="p-6 max-w-xl">
        <p className="text-slate-600 dark:text-slate-300">
          {t("mintSpace.supportDisabledShort")}
        </p>
      </div>
    );
  }

  return (
    <div className="w-full">
      <MintSpaceSupportHub
        isDark={isDark}
        setToast={setToast}
        mintSpace={mintSpace}
        isOwner={isMintSpaceOwner}
        isModerator={isMintSpaceModerator}
        onSupportUnreadChange={onSupportUnreadChange}
      />
    </div>
  );
};

export default MintSpaceSupportPage;
